<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-align: center;">Terry Wilson is the author of <em>Fifty</em>, <em>Natural</em>, <em>Fox Spirit</em>, <em>The Lane and Other Poems</em>, and <em>At The Blue Door</em>.</p>
<p style="text-align: center;">He lives in Adelaide, South Australia.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?38914e3f